// eslint-disable-next-line no-restricted-globals
export const isWWWinURL = () => location.href.toString().includes('www');